<template>
    <div class="c-basket-variant">
        <span class="item">
            <span v-tooltip="$t('customer.checkout.pieces_in_backorder', {'amount': productLine.ProductAmount- productLine.Stock})" v-if="!productLine.IsPreOrder && (productLine.Stock - productLine.ProductAmount < 0)" class="backorder-label">Backorder</span>
            <span v-if="productLine.IsPreOrder" class="backorder-label">Pre-order</span>
        </span>
        <span class="item">{{productLine.ProductSize}}</span>
        <span class="item">{{productLine.ProductPrice | currency(customerCurrencySymbol) }}</span>
        <span v-if="productLine.ProductDiscount" class="item">{{ productLine.ProductDiscount | currency(customerCurrencySymbol) }} ({{ productLine.ProductDiscountPercentage }}%)</span>
        <span v-else class="item">-</span>
        <span class="item">
            <v-input v-model="productLine.ProductAmount"
                    type="number"
                    @change="updateProductAmount"
                    custom-class="u-inline-block"
                    name="amount"
                    width="70px"
                    :min=1
                    :error="error">
            </v-input>
        </span>
        <span class="item">{{ productLine.ProductTotal | currency(customerCurrencySymbol) }}</span>
        <span class="item">
            <span v-tooltip="'Uit winkelwagen verwijderen'" @click="deleteProduct">
                <svgicon class="delete" name="close" color="#EF7D01"></svgicon>
            </span>
        </span>
    </div>
</template>
<script>
    import debounce from 'lodash/debounce'
    import VInput from '@/components/form/Input'
    import VProductDelete from '@/components/product/widgets/productDelete'

    export default {
        props: {
          productId: Number,
          productLine: Object
        },
        components: {
           VInput,
           VProductDelete
        },
        data(){
            return {
                error: null
            }
        },
        computed: {
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            updateProductAmount: debounce(function(){
                this.$store.dispatch("updateItemInBasket", {
                    productVariantId : this.productLine.ProductVariantId,
                    productId : this.productId,
                    Amount : this.productLine.ProductAmount
                }).then(result => {
                    if (result.Error) {
                        this.error = result.Error;
                        this.$emit('outOfStock', this.productLine.ProductVariantId);
                    } else {
                        this.error = null;
                        this.$emit('inStock', this.productLine.ProductVariantId);
                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.basket.product_updated'),
                            type: 'success',
                            duration: 4000
                        });
                        this.productLine.ProductTotal = (this.productLine.ProductPrice - this.productLine.ProductDiscount) * this.productLine.ProductAmount;
                    }
                });
            }, 500),
            deleteProduct() {
                const confirm = window.confirm('Weet u zeker dat u het product uit de winkelwagen wilt verwijderen?')
                if (confirm) {
                    this.$store.dispatch("removeItemFromBasket",{
                        productVariantId: this.productLine.ProductVariantId
                    }).then(()=> {
                        this.$emit('inStock', this.productLine.ProductVariantId);
                        this.$store.dispatch("getBasket");
                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.basket.product_removed'),
                            type: 'success',
                            duration: 4000
                        });
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .delete {
        cursor: pointer;
        margin-left: 4px;
        &:hover {
            opacity: 0.6;
        }
    }

    .backorder-label {
        padding:em($global-spacing-unit-tiny);
        color: $color-white;
        background-color:$color-promo;
    }
</style>



// WEBPACK FOOTER //
// src/components/basket/ProductVariant.vue